import { Box, IconButton, InputAdornment, TextField, Tooltip, type TextFieldProps } from "@mui/material";
import { FormatColorReset } from "@mui/icons-material";

const HEX = /^#[0-9a-f]{6}$/i;

type ColorFieldProps = Omit<TextFieldProps, "value" | "onChange"> & {
  value: string;
  onChange: (cor: string) => void;
  // Com valorPadrao, um botão no fim do campo volta a ele; só aparece quando a cor é outra.
  valorPadrao?: string;
};

// Código "#rrggbb" digitável, com o quadradinho que abre o seletor do navegador.
// O seletor só entende cor completa: enquanto o texto não é uma, ele mostra preto.
export function ColorField({ value, onChange, valorPadrao, slotProps, ...props }: ColorFieldProps) {
  const foraDoPadrao = valorPadrao !== undefined && value.trim().toLowerCase() !== valorPadrao.toLowerCase();
  return (
    <TextField
      {...props}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        ...slotProps,
        input: {
          startAdornment: (
            <Box
              component="input"
              type="color"
              aria-label={`Escolher ${typeof props.label === "string" ? props.label.toLowerCase() : "cor"}`}
              value={HEX.test(value) ? value.toLowerCase() : "#000000"}
              onChange={(e) => onChange((e.target as HTMLInputElement).value)}
              sx={{
                width: 24,
                height: 24,
                border: "none",
                p: 0,
                mr: 1,
                cursor: "pointer",
                background: "none",
              }}
            />
          ),
          endAdornment: foraDoPadrao && (
            <InputAdornment position="end">
              <Tooltip title="Voltar ao padrão">
                <IconButton aria-label="Voltar ao padrão" size="small" edge="end" onClick={() => onChange(valorPadrao ?? "")}>
                  <FormatColorReset fontSize="small" />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
